<template>
  <div>
    <client-history
      v-if="customer"
      :orders="orders"
      :contacts="contacts"
      :loading="loading"
      :reverse="!isIntegrated"
      :is-integrated="isIntegrated"
      @contact-page-change="fetch"
      @events-clicked="showOutreachDetails"
    />
    <client-email-events-container
      v-if="outreachSelected"
      :show="showOutreachDetailsModal"
      :outreach-id="outreachSelected.pk"
      :customer="customer"
      :edit="outreachSelected.edit"
      @closed="showOutreachDetailsModal = false"
    />
  </div>
</template>
<script>
import Integrable from '@/components/mixins/integrable';
import ClientEmailEventsContainer from '@/components/Widgets/ClientHistory/ClientEmailEventsContainer';
import ClientHistory from './ClientHistory';
import minHeightMixin from '../mixins/minheight';

export default {
  name: 'ClientHistoryContainer',
  components: {
    ClientHistory,
    ClientEmailEventsContainer,
  },
  mixins: [minHeightMixin, Integrable],
  data() {
    return {
      showOutreachDetailsModal: false,
      outreachSelected: null,
    };
  },
  computed: {
    customer() {
      return this.$store.state.customers.item;
    },
    orders() {
      if (!this.customer || !this.customer.transactions) return [];
      return this.customer.transactions;
    },
    contacts() {
      if (!this.customer) return { count: 0, items: [] };
      return {
        count: this.$store.state.outreachs.customerOutReachContactsCount,
        items: this.$store.state.outreachs.customerOutReachContacts,
      };
    },
    loading() {
      return this.$store.state.customers.itemLoading
        || this.$store.state.outreachs.corcsLoading;
    },
  },
  watch: {
    customer(newval, old) {
      if (!newval || !newval.pk) {
        return;
      }
      if (newval.pk === old.pk) {
        return;
      }

      this.fetch();
    },
  },
  methods: {
    fetch(paginationParams = { page_size: 6, page: 1 }) {
      if (!this.customer || !this.customer.pk) {
        return;
      }
      this.$store.dispatch('outreachs/fetchCustomerOutreachContact', {
        customer_id: this.customer.pk,
        ...paginationParams,
      });
    },
    showOutreachDetails(outreach) {
      this.outreachSelected = outreach;
      this.showOutreachDetailsModal = true;
    },
  },
};
</script>
